import { render, staticRenderFns } from "./my-uploads.vue?vue&type=template&id=721148b0&scoped=true"
import script from "./my-uploads.vue?vue&type=script&lang=js"
export * from "./my-uploads.vue?vue&type=script&lang=js"
import style0 from "./my-uploads.vue?vue&type=style&index=0&id=721148b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721148b0",
  null
  
)

export default component.exports